import React, { useEffect, useState } from "react";
import Breadcrumb from "../Breadcrumb";
import Section from "../Section";
import { pageTitle } from "../../helpers/PageTitle";
import {
  FaSolarPanel,
  FaLightbulb,
  FaFan,
  FaWater,
  FaCogs,
  FaTools,
} from "react-icons/fa";

export default function ProductsPage() {
  pageTitle("Solar Products");
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const productData = [
    {
      title: "Setup Details",
      category: "Setup Details",
      images: [
        "/images/products/sd-4.jpg",
        "/images/products/sd-5.webp",
        "/images/products/sd-6.png",
      ],
      description: [
        "Panel – 25 Years of Performance Warranty",
        "Inverter – 5 Years + Extended Warranty Package",
        "EPC System is Designed, Procured & Installed by Riyansh Solar Power Plus Pvt. Ltd.",
      ],
    },
    {
      title: "Wall Lights",
      category: "Wall Lights",
      images: [
        "/images/products/l-5.png",
        "/images/products/l-6.png",
        "/images/products/l-7.png",
      ],
      description: [
        "Solar Wall Light – 1 Year of Product Warranty",
        "Add On Protection – 1 Year Extended Warranty",
      ],
    },
    {
      title: "Outdoor",
      category: "Outdoor",
      images: [
        "/images/products/outdor-5.png",
        "/images/products/outdor-6.png",
        "/images/products/outdor-7.png",
      ],
      description: [
        "Outdoor Light – 1 Year of Product Warranty",
        "Add On Protection – 1 Year Extended Warranty",
      ],
    },
    {
      title: "Fans",
      category: "Fans",
      images: [
        "/images/products/fan-8.png",
        "/images/products/fan-9.png",
        "/images/products/fan-10.png",
      ],
      description: [
        "Solar Fans – Up to 15 Years of Product Warranty",
        "Add On Protection – 5 Years Extended Warranty",
      ],
    },
    {
      title: "Street Light",
      category: "Street Light",
      images: [
        "/images/products/sl-5.png",
        "/images/products/sl-6.png",
        "/images/products/sl-7.png",
      ],
      description: [
        "Solar Street Light – Up to 5 Years of Product Warranty",
        "Add On Protection – 1 Year Extended Warranty",
      ],
    },
    {
      title: "Mini Light",
      category: "Mini Light",
      images: [
        "/images/products/sm-5.png",
        "/images/products/sm-6.png",
        "/images/products/sm-7.png",
      ],
      description: ["Solar Mini Light – Up to 1 Year of Product Warranty"],
    },
    {
      title: "Grid DIY",
      category: "Grid DIY",
      images: [
        "/images/products/gd-4.png",
        "/images/products/gd-5.png",
        "/images/products/gd-6.png",
      ],
      description: [
        "Panel – 25 Years of Performance Warranty",
        "Inverter – 2 Years + Extended Warranty Package",
        "Battery – 2 Years DIY System Ready Package (All materials included, without installation)",
      ],
    },
    {
      title: "Water Pump",
      category: "Water Pump",
      images: [
        "/images/products/wp-4.png",
        "/images/products/wp-5.png",
        "/images/products/wp-6.png",
      ],
      description: [
        "Panel – 25 Years of Performance Warranty",
        "Pump – 1 Year + Extended Warranty",
        "Controller – 1 Year + Extended Warranty",
        "Structure + Pipe + Installation Can be provided with additional charges from Riyansh Solar Power Plus.",
      ],
    },
  ];

  const categories = [
    { name: "All Products", icon: <FaSolarPanel /> },
    { name: "Setup Details", icon: <FaCogs /> },
    { name: "Wall Lights", icon: <FaLightbulb /> },
    { name: "Outdoor", icon: <FaLightbulb /> },
    { name: "Fans", icon: <FaFan /> },
    { name: "Street Light", icon: <FaLightbulb /> },
    { name: "Mini Light", icon: <FaLightbulb /> },
    { name: "Grid DIY", icon: <FaTools /> },
    { name: "Water Pump", icon: <FaWater /> },
  ];

  const [selectedCategory, setSelectedCategory] = useState("All Products");

  const filteredProducts =
    selectedCategory === "All Products"
      ? productData
      : productData.filter((p) => p.category === selectedCategory);

  return (
    <>
      <Breadcrumb title="Products" bgUrl="https://png.pngtree.com/thumb_back/fh260/background/20210814/pngtree-business-gradient-geometric-gray-square-abstract-simple-gray-background-image_759189.jpg" />

      <Section pt="120" pb="100">
        <div className="container">
          {/* ===== Header ===== */}
          <div className="text-center mb-5">
            <h2 className="fw-bold">
              {selectedCategory === "All Products"
                ? "Comprehensive Range of High-Quality Solar Products"
                : selectedCategory}
            </h2>
            <p className="text-muted">
              All our products come with extensive warranties and are built for
              long-lasting performance.
            </p>
          </div>

          {/* ===== Filter Buttons ===== */}
          <div className="d-flex flex-wrap justify-content-center gap-3 mb-5">
            {categories.map((cat) => (
              <button
                key={cat.name}
                onClick={() => setSelectedCategory(cat.name)}
                className={`btn ${
                  selectedCategory === cat.name
                    ? "btn-primary text-white"
                    : "btn-outline-primary"
                } d-flex align-items-center gap-2`}
                style={{ borderRadius: "50px", padding: "8px 18px" }}
              >
                {cat.icon}
                <span>{cat.name}</span>
              </button>
            ))}
          </div>

          {/* ===== Product Cards ===== */}
          {filteredProducts.map((product, index) => (
            <div
              key={index}
              className="product-card mb-5 p-4 rounded shadow-sm bg-light"
            >
              <h3 className="text-accent mb-3">{product.title}</h3>

              {/* Images */}
              <div className="product-images d-flex flex-wrap justify-content-center gap-3 mb-3">
                {product.images.map((img, i) => (
                  <img
                    key={i}
                    src={img}
                    alt={product.title}
                    className="rounded"
                    style={{
                      width: "300px",
                      maxWidth: "100%",
                      height: "200px",
                      objectFit: "cover",
                    }}
                  />
                ))}
              </div>

              {/* Description */}
              <ul className="text-dark ps-3">
                {product.description.map((desc, j) => (
                  <li key={j} className="mb-1">
                    {desc}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </Section>
    
    </>
  );
}
